export default __webpack_public_path__ + "static/media/Photo 4 - BR - balcons les uns sous les autres.6e0d9d75.jpg";